import { render, staticRenderFns } from "./social-media-widgets.vue?vue&type=template&id=cf300032&scoped=true"
import script from "./social-media-widgets.vue?vue&type=script&lang=js"
export * from "./social-media-widgets.vue?vue&type=script&lang=js"
import style0 from "./social-media-widgets.vue?vue&type=style&index=0&id=cf300032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf300032",
  null
  
)

export default component.exports